<template>
  <div class="p-grid p-mt-4" v-if="car">
    <div class="p-col-12 p-md-12 p-lg-6 p-fluid info-card">
      <Panel :header="$t('General information')">
        <div class="panel-inner">
          <div class="panel-info-block-grid">
            <div class="panel-info-block-label p-p-1">{{ $t('Owner') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <CustomerData v-if="car.customer" :user="car.customer"/>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Make') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="carMakeName(car)">{{ carMakeName(car) }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Model') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="carModelName(car)">{{ carModelName(car) }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <template v-if="!isForkliftTenant">
              <div class="panel-info-block-label p-p-1">{{ $t('Plate number') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <span v-if="car.plate_number">{{ car.plate_number }}</span>
                <i v-else class="ti-minus"/>
              </div>
            </template>

            <template v-if="!isForkliftTenant">
              <div class="panel-info-block-label p-p-1">{{ $t('VIN number') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <span v-if="car.vin">{{ car.vin }}</span>
                <i v-else class="ti-minus"/>
              </div>
            </template>

            <template v-if="isForkliftTenant">
              <div class="panel-info-block-label p-p-1">{{ $t('Serial Number') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <span v-if="car.serial_number">{{ car.serial_number }}</span>
                <i v-else class="ti-minus"/>
              </div>
            </template>

            <template v-if="!isForkliftTenant">
              <div class="panel-info-block-label p-p-1">{{ $t('Engine code') }}:</div>
              <div class="panel-info-block-value p-p-1">
                <span v-if="car.engine_code">{{ car.engine_code }}</span>
                <i v-else class="ti-minus"/>
              </div>
            </template>

            <div class="panel-info-block-label p-p-1">{{ $t('Year') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="car.year">{{ car.year }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <template v-if="car.power">
              <div class="panel-info-block-label p-p-1">{{ $t('Power') }} ({{ (settings.measurements.power) }}):</div>
              <div class="panel-info-block-value p-p-1">
                {{ car.power }}
              </div>
            </template>

            <div class="panel-info-block-label p-p-1">{{ $t('Comment') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <span v-if="car.comment">{{ car.comment }}</span>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('creationLocation') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <template v-if="car.creationLocationName">{{ car.creationLocationName }}</template>
              <i v-else class="ti-minus"/>
            </div>

            <div class="panel-info-block-label p-p-1">{{ $t('Created') }}:</div>
            <div class="panel-info-block-value p-p-1">
              <template v-if="car.created_at">
                {{ formatBy(car.created_at, car.creator) }}
              </template>
              <i v-else class="ti-minus"/>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import settings from '@/settings.js'
import formatMixins from '@/mixins/formatMixins'
import CustomerData from "@/components/CustomerData.vue";

export default {
  mixins: [ formatMixins ],
  components: { CustomerData },
  // emits: ['change-customer-status'],
  props: {
    car: {
      type: Object,
      default: null
    },
  },
	data() {
		return {
      // carId: null,
      // isLoading: true,
      // carData: null,
      settings,
		}
	},
  computed: {
    isForkliftTenant() {
      return this.$store.getters.isForkliftTenant
    }
  }
}
</script>